module.exports = __webpack_public_path__ + "img/test_btn.68330a3c.png";